import api from "./api";

export interface ProfileData {
  id: number | string;
  name: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  username?: string | null;
  phone?: string | null;
  role: string;
  roleId?: number | null;
  roleName?: string | null;
  departmentId?: number | null;
  departmentName?: string | null;
  active?: boolean;
  isValidated?: boolean;
  createdAt?: string;
  isDoctor?: boolean;
  gender?: string | null;
  registrationNumber?: string | null;
  status?: string | null;
  contact?: string | null;
  profileSummary?: string | null;
  qualifications?: string | null;
  clinicalSummary?: string | null;
  is_reviewer?: boolean;
  reviewer_id?: number | null;
  reviewerName?: string | null;
}

export interface UpdateProfilePayload {
  name?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  department_id?: number | null;
  gender?: string | null;
  qualifications?: string | null;
  profileSummary?: string | null;
  clinicalSummary?: string | null;
}

const unwrap = <T>(result: T | { data: T }): T =>
  result && typeof result === "object" && "data" in result
    ? (result as { data: T }).data
    : (result as T);

export const getProfile = async (): Promise<ProfileData> => {
  const response = await api.get("/api/profile/me");
  return unwrap<ProfileData>(response.data);
};

export const updateProfile = async (
  payload: UpdateProfilePayload
): Promise<ProfileData> => {
  const response = await api.put("/api/profile/me", payload);
  return unwrap<ProfileData>(response.data);
};

export const updateName = async (name: string): Promise<ProfileData> => {
  const response = await api.put("/api/profile/name", { name });
  return unwrap<ProfileData>(response.data);
};

export const changePassword = async (
  currentPassword: string,
  newPassword: string,
  confirmPassword: string
): Promise<{ message: string }> => {
  const response = await api.put("/api/profile/password", {
    currentPassword,
    newPassword,
    confirmPassword,
  });
  return unwrap<{ message: string }>(response.data);
};

export const requestEmailChange = async (
  newEmail: string
): Promise<{ message: string; otp?: string; pendingEmail?: string; expirySeconds?: number }> => {
  const response = await api.post("/api/profile/email/change-request", { newEmail });
  return unwrap<{ message: string; otp?: string; pendingEmail?: string; expirySeconds?: number }>(
    response.data
  );
};

export const verifyEmailChange = async (otp: string): Promise<ProfileData> => {
  const response = await api.post("/api/profile/email/verify", { otp });
  return unwrap<ProfileData>(response.data);
};
